export const calculateAverage = (numArr, decimalDigits = 1) => {
  return (numArr.reduce((a, b) => a + b) / numArr.length)?.toFixed(decimalDigits)
}